// Tile grid overlay: lines between tiles, toggleable from the HUD.
// Drawn above furniture but below characters so it doesn't obscure sprites.
import { PALETTE as C } from "./palette.js";

export function drawGridOverlay(scene, cols, rows, tileSize) {
  const g = scene.add.graphics();
  g.setDepth(2);
  g.lineStyle(1, C.gold, 0.15);
  // Vertical lines
  for (let x = 0; x <= cols; x++) {
    g.lineBetween(x * tileSize, 0, x * tileSize, rows * tileSize);
  }
  // Horizontal lines
  for (let y = 0; y <= rows; y++) {
    g.lineBetween(0, y * tileSize, cols * tileSize, y * tileSize);
  }
  // Slightly stronger every 4 tiles for readability
  g.lineStyle(1, C.gold, 0.28);
  for (let x = 0; x <= cols; x += 4) {
    g.lineBetween(x * tileSize, 0, x * tileSize, rows * tileSize);
  }
  for (let y = 0; y <= rows; y += 4) {
    g.lineBetween(0, y * tileSize, cols * tileSize, y * tileSize);
  }
  g.setVisible(false); // off by default in free-roam
  return g;
}

// Draw a subtle highlight on the tile currently under the pointer.
export function drawHoverHighlight(scene, tileSize) {
  const g = scene.add.graphics();
  g.setDepth(2);
  g.setVisible(false);
  return {
    graphics: g,
    show(col, row) {
      g.clear();
      g.lineStyle(2, C.gold, 0.7);
      g.strokeRect(col * tileSize + 1, row * tileSize + 1, tileSize - 2, tileSize - 2);
      g.setVisible(true);
    },
    hide() { g.setVisible(false); },
  };
}
